import { create, ZoidComponent } from 'zoid/dist/zoid.frameworks'
import { commonComponentsProps } from '../../common/props'
import bannerSkeleton from './bannerSkeleton'

const cdc: ZoidComponent = create({
  tag: 'mbo-cdc-carriers-banner',

  url: import.meta.env.VITE_VUE_URL + '/#/carriers-banner',

  context: 'iframe',

  dimensions: {
    width: '100%',
    height: '100%',
  },

  autoResize: {
    width: false,
    height: true,
  },
  prerenderTemplate: bannerSkeleton,

  props: {
    ...commonComponentsProps,

    controllerName: {
      type: 'string',
      required: false,
    },
    handleOpenDialog: {
      type: 'function',
      required: false,
    },
    setBannerSeen: {
      type: 'function',
      required: true,
    }
  },
})

export default cdc
